import { Button, Card, CardContent, CardHeader, CardTitle } from '@e2n/ui/v2';
import { useDatevAuthContext } from '../lib/DatevAuthContext';
import { cn } from 'cn';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

// oxlint-disable-next-line complexity
export function DatevAuthCard() {
  const { status, setStatus } = useDatevAuthContext();
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Verbindungsstatus</CardTitle>
      </CardHeader>

      <CardContent>
        <div className="flex items-center gap-2">
          <span
            className={cn(
              'w-2.5 h-2.5 rounded-full shrink-0',
              status?.authorized
                ? 'bg-primary-green-500'
                : 'bg-primary-red-500',
            )}
          />
          {status?.authorized ? (
            <span>
              Verbunden als <strong>{status.name}</strong>
            </span>
          ) : (
            <span>Nicht angemeldet</span>
          )}
        </div>
        {status?.authorized && status.expiresAt && (
          <p className="mt-2.5 text-sm text-gray-500">
            Token gültig bis:{' '}
            {dayjs(status.expiresAt).format('DD.MM.YYYY HH:mm')}
          </p>
        )}
        <div className="mt-4">
          {status?.authorized ? (
            <Button
              variant={'secondary-blue'}
              className="text-sm cursor-pointer"
              onClick={() => setStatus(null)}>
              Abmelden
            </Button>
          ) : (
            <Button onClick={() => navigate('/datev/login')}>
              Bei DATEV Anmelden
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
